import {
  type DashboardActions,
  InternalProjectActions as Internal,
} from '@store/reducers/dashboard/actions'
import { selectProjectParents } from '@store/reducers/dashboard/selectors'
import type { ProjectParents } from '@store/reducers/dashboard/types'
import { notificationActionCreators } from '@storeOld/reducers/notification'
import { call, put, select } from 'redux-saga/effects'

import { GtmTriggerName, sendGtmEvent } from '@/constants/gtm'
import { NestClient } from '@/nest'

export function* archive({
  payload: { id },
}: ReturnType<typeof DashboardActions.projects.archive>) {
  const path: ProjectParents | null = yield select(selectProjectParents(id))

  if (!path) {
    return
  }

  const { project, workspace } = path

  yield put(Internal.delete({ id }))

  yield put(
    Internal.add({
      workspaceId: workspace.id,
      folderId: 'archive',
      project: { ...path.project, archived: true },
    })
  )

  yield put(
    notificationActionCreators.setCustomNotification({
      toastContainerId: 'secondary',
      type: 'gray',
      text: `${project.title} archived`,
    })
  )

  sendGtmEvent(GtmTriggerName.PROJECT_ARCHIVE)

  yield call(NestClient.projects.archive, { ids: [id] })
}
